import { z } from 'zod'

// the avatar is a 256×256 JPEG data URL from the crop dialog (well under 100 KB); the cap leaves
// room for other encoders while staying inside the 2 MB body limit of PATCH /users/me
export const AVATAR_DATA_URL_MAX_LENGTH = 1_000_000

export const updateProfileSchema = z.object({
  name: z
    .string()
    .min(1, 'Name must not be empty')
    .max(100, 'Name must not exceed 100 characters')
    .optional(),
  avatar: z.string().max(AVATAR_DATA_URL_MAX_LENGTH, 'Avatar image is too large').optional(),
})

export type UpdateProfileDto = z.infer<typeof updateProfileSchema>
